import "../../Styles/ClientSetupStepper.css";

function ClientSetupStepper({
  currentStep,
  selectedRelationFrClient,
  parent,
}) {
  return (
    <div className="client-setup-stepper-wrapper">

      {/* STEP 1 */}
      <div
        className={`client-setup-step-box ${
          currentStep >= 1
            ? "client-setup-active-step"
            : ""
        }`}
      >
        Profile details
      </div>

      {selectedRelationFrClient !== parent ? (
        <>
          {/* SELF ONLY */}
          <div className="client-setup-step-line-div"></div>

          <div
            className={`client-setup-step-box ${
              currentStep >= 2 ? "client-setup-active-step" : ""
            }`}
          >
            Match Preferences
          </div>

          <div className="client-setup-step-line-div"></div>

          <div
            className={`client-setup-step-box ${
              currentStep >= 3 ? "client-setup-active-step" : ""
            }`}
          >
            Payment
          </div>
        </>
      ) : (
        <>
          <div className="client-setup-step-line-div"></div>

          <div
            className={`client-setup-step-box ${
              currentStep >= 2 ? "client-setup-active-step" : ""
            }`}
          >
            Payment
          </div>
        </>
      )}
    </div>
  );
}

export default ClientSetupStepper;